<template>
  <v-container class="mt-5">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <h2 class="text-center mb-4">{{ $t('FAQs') }}</h2>

        <v-expansion-panels multiple>
          <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
            <v-expansion-panel-title>
              <strong>{{ faq.q }}</strong>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              {{ faq.a }}
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'FAQ',
  computed: {
    faqs () {
      const email = 'info@dreamdealtech.com'
      return [
        { q: this.$t('FAQ.q1'), a: this.$t('FAQ.a1', { email }) },
        { q: this.$t('FAQ.q2'), a: this.$t('FAQ.a2') },
        { q: this.$t('FAQ.q3'), a: this.$t('FAQ.a3') },
        { q: this.$t('FAQ.q4'), a: this.$t('FAQ.a4') },
        { q: this.$t('FAQ.q5'), a: this.$t('FAQ.a5') },
        { q: this.$t('FAQ.q6'), a: this.$t('FAQ.a6') },
        { q: this.$t('FAQ.q7'), a: this.$t('FAQ.a7') },
        { q: this.$t('FAQ.q8'), a: this.$t('FAQ.a8') },
        { q: this.$t('FAQ.q9'), a: this.$t('FAQ.a9', { email }) }
      ]
    }
  }
}
</script>
